
const NotFound = () => {
    return (
        <div className="text-center">
            <h3>
              Страница не найдена
            </h3>
            <span lang="ja">¯\_(ツ)_/¯</span>
        </div>
    );
};

export default NotFound;
